import React from 'react';
import PropTypes from 'prop-types';

const ComplianceOverviewCard = ({
  score,
  totalChecks,
  statusCounts,
  highlight,
  breakdown,
}) => {
  const normalizedScore = Math.max(0, Math.min(score, 100));

  return (
    <section className="compliance-overview">
      <div className="overview-header">
        <div className="score-badge">
          <span className="score-value">{normalizedScore}</span>
          <span className="score-label">Compliance score</span>
        </div>
        <div className="score-progress">
          <div className="progress-track">
            <div
              className={`progress-fill status-${breakdown.overallStatus}`}
              style={{ width: `${normalizedScore}%` }}
            />
          </div>
          <p className="progress-summary">{highlight}</p>
          <span className="progress-meta">
            {totalChecks} core checks · {statusCounts.pass} pass · {statusCounts.warning} warning · {statusCounts.fail} fail
          </span>
        </div>
      </div>

      <div className="overview-breakdown">
        <div className="breakdown-item">
          <span className="breakdown-icon">🟢</span>
          <div className="breakdown-copy">
            <span className="breakdown-title">Healthy</span>
            <span className="breakdown-value">{statusCounts.pass} passing checks</span>
          </div>
        </div>
        <div className="breakdown-item">
          <span className="breakdown-icon">🟡</span>
          <div className="breakdown-copy">
            <span className="breakdown-title">Watch list</span>
            <span className="breakdown-value">{statusCounts.warning} warnings detected</span>
          </div>
        </div>
        <div className="breakdown-item">
          <span className="breakdown-icon">🔴</span>
          <div className="breakdown-copy">
            <span className="breakdown-title">Action needed</span>
            <span className="breakdown-value">{statusCounts.fail} failing checks</span>
          </div>
        </div>
      </div>
    </section>
  );
};

ComplianceOverviewCard.propTypes = {
  score: PropTypes.number.isRequired,
  totalChecks: PropTypes.number.isRequired,
  statusCounts: PropTypes.shape({
    pass: PropTypes.number,
    warning: PropTypes.number,
    fail: PropTypes.number,
  }).isRequired,
  highlight: PropTypes.string.isRequired,
  breakdown: PropTypes.shape({
    overallStatus: PropTypes.oneOf(['pass', 'warning', 'fail']).isRequired,
  }).isRequired,
};

export default ComplianceOverviewCard;






















